import Nullstack from 'nullstack';
export default function IconVirusOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-virus-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), "   ", Nullstack.element("path", {
    d: "M8.469 8.46a5 5 0 0 0 7.058 7.084"
  }), "   ", Nullstack.element("path", {
    d: "M16.913 12.936a5 5 0 0 0 -5.826 -5.853"
  }), "   ", Nullstack.element("path", {
    d: "M12 7v-4"
  }), "   ", Nullstack.element("path", {
    d: "M11 3h2"
  }), "   ", Nullstack.element("path", {
    d: "M15.536 8.464l2.828 -2.828"
  }), "   ", Nullstack.element("path", {
    d: "M17.657 4.929l1.414 1.414"
  }), "   ", Nullstack.element("path", {
    d: "M17 12h4"
  }), "   ", Nullstack.element("path", {
    d: "M21 11v2"
  }), "   ", Nullstack.element("path", {
    d: "M18.364 18.363l-.707 .707"
  }), "   ", Nullstack.element("path", {
    d: "M12 17v4"
  }), "   ", Nullstack.element("path", {
    d: "M13 21h-2"
  }), "   ", Nullstack.element("path", {
    d: "M8.465 15.536l-2.829 2.828"
  }), "   ", Nullstack.element("path", {
    d: "M6.343 19.071l-1.413 -1.414"
  }), "   ", Nullstack.element("path", {
    d: "M7 12h-4"
  }), "   ", Nullstack.element("path", {
    d: "M3 13v-2"
  }), "   ", Nullstack.element("path", {
    d: "M5.636 5.637l-.707 .707"
  }), " ");
}